import { useStore } from 'zustand';

import { environmentStore } from '@/react/hooks/current-environment-store';
import { notifySuccess } from '@/portainer/services/notifications';

import { PageHeader } from '@@/PageHeader';

import { Environment } from '../types';

import { EnvironmentsDatatable } from './EnvironmentsDatatable';
import { useDeleteEnvironmentsMutation } from './useDeleteEnvironmentsMutation';
import { confirmDeleteEnvironments } from './ConfirmDeleteEnvironmentsModal';

export function ListView() {
  const constCurrentEnvironmentStore = useStore(environmentStore);
  const deletionMutation = useDeleteEnvironmentsMutation();

  return (
    <>
      <PageHeader
        title="Environments"
        breadcrumbs="Environment management"
        reload
      />

      <EnvironmentsDatatable onRemove={handleRemove} />
    </>
  );

  async function handleRemove(environmentsToDelete: Environment[]) {
    const { confirmed, deleteClusters } =
      (await confirmDeleteEnvironments(environmentsToDelete)) || {};

    if (!confirmed) {
      return;
    }

    // If we're deleting the current endpoint, then clean the endpoint store
    const selectedEnvId = constCurrentEnvironmentStore.environmentId;
    if (environmentsToDelete.some((e) => e.Id === selectedEnvId)) {
      constCurrentEnvironmentStore.clear();
    }

    deletionMutation.mutate(
      environmentsToDelete.map((e) => ({
        id: e.Id,
        deleteCluster: Boolean(e.CloudProvider) && deleteClusters,
        name: e.Name,
      })),
      {
        onSuccess() {
          notifySuccess(
            'Environments successfully removed',
            environmentsToDelete.map((e) => e.Name).join(', ')
          );
        },
      }
    );
  }
}
